export const inputTextTheme = {
  colorScheme: {
    light: {
      root: {
        focusRing: {
          width: '1px',
          style: 'solid',
          color: 'var(--surface-accent-main)',
          offset: '0',
          shadow: 'none'
        }
      }
    },
    dark: {
      root: {
        focusRing: {
          width: '1px',
          style: 'solid',
          color: 'var(--surface-accent-main)',
          offset: '0',
          shadow: 'none'
        }
      }
    }
  }
};
